package com.patronat.top.features.usermanagement.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.domain.models.profiles.User
import com.patronat.top.features.usermanagement.domain.repository.ProfileRepository
import com.patronat.top.features.usermanagement.domain.usecase.command.GetCurrentUserCommand
import com.patronat.top.domain.usecase.BaseUseCase

class GetCurrentUserUseCase(
    val userRepository: ProfileRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetCurrentUserCommand, DomainResult<User>>(
    dispatcher = dispatcherProvider.io
){
    override suspend fun doWork(command: GetCurrentUserCommand): DomainResult<User> {
        return userRepository.getCurrentUser()
    }
}